export default "__VITE_ASSET__Bd0mzDb$__"